/**
 * @generated SignedSource<<92d59e118fb7bc0a50a5a8a7bbe563ee>>
 * @relayHash d9b80c527569b80e2e038d76efea2550
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 10f89b5592832b464377606e93dd875592eea5b11713b3e6d91d592d6982620f

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type pickerContentQuery$variables = {
  cloudId: string;
  issueAris: ReadonlyArray<string>;
};
export type pickerContentQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pickerContent_autodevAgentPicker_agentsFragRef">;
};
export type pickerContentQuery = {
  response: pickerContentQuery$data;
  variables: pickerContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueAris"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "pickerContentQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "issueAris",
            "variableName": "issueAris"
          }
        ],
        "kind": "FragmentSpread",
        "name": "pickerContent_autodevAgentPicker_agentsFragRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pickerContentQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Literal",
            "name": "first",
            "value": 20
          },
          {
            "kind": "Variable",
            "name": "issueIds",
            "variableName": "issueAris"
          }
        ],
        "concreteType": "DevAiRovoAgentConnection",
        "kind": "LinkedField",
        "name": "devai_autodevRovoAgents",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isRankingLimitApplied"
          },
          {
            "concreteType": "DevAiRovoAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "DevAiRovoAgent",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "identityAccountId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "externalConfigReference"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "rankCategory"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "devai_autodevRovoTemplates",
        "args": [
          (v1/*: any*/),
          {
            "kind": "Literal",
            "name": "first",
            "value": 1
          },
          {
            "kind": "Literal",
            "name": "templatesFilter",
            "value": "ONLY"
          }
        ],
        "concreteType": "DevAiRovoAgentConnection",
        "kind": "LinkedField",
        "name": "devai_autodevRovoAgents",
        "plural": false,
        "selections": [
          {
            "concreteType": "DevAiRovoAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "DevAiRovoAgent",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "10f89b5592832b464377606e93dd875592eea5b11713b3e6d91d592d6982620f",
    "metadata": {},
    "name": "pickerContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3550a100e40c5dbf5f732444d35e37b3";

export default node;
